import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const slice = createSlice({
  name: 'providerManagement',
  initialState: {
    userListLoading: false,
    usersList: [],

    slotType: [],
    appointmentStatus: [],

    paginationData: {},
    doctorPaginationData: {},
    hospitalPaginationData: {},
    pharmacyPaginationData: {},
    scanCenterPaginationData: {},
    laboratoryPaginationData: {},
    ambulancePaginationData: {},

    bookingListLoading: false,
    bookingList: [],
    bookingPagingData: {},
    updateBooking: false,

    detailBookingLoading: false,
    detailBookingData: {},

    doctorListLoading: false,
    doctorList: [],
    hospitalListLoading: false,
    hospitalList: [],
    pharmacyListLoading: false,
    pharmacyList: [],
    scanCenterListLoading: false,
    scanCenterList: [],
    laboratoryListLoading: false,
    laboratoryList: [],
    ambulanceListLoading: false,
    ambulanceList: [],
    cityList: [],
    cityLoading: false,
    scanCategoryList: [],
    ambulanceType: [],
    ambulanceFacilities: [],
    appointmentDuration: [],

    doctorSlotList: [],
    imaBranch: [],
    updateUser: false,
    updateHospital: false,
    updateDoctor: false,
    updatePharmacyList: false,
    updateScanCenter: false,
    updateLaboratory: false,
    updateAmbulance: false,
    addPharmacyApiSuccess: false,
    addPharmacyApiError: [],
    approvedSuccess: false,
    cityPaginationData: {},
    addCityApiSuccess: false,
    deleteCityApiSuccess: false,
    editCityApiSuccess: false,
    cityApiError: null,
    updateCityList: false,
    ApiError: '',
    modalOpen: false,
  },
  reducers: {
    //user
    getUserData: (state, { payload }) => {
      state.userListLoading = true
    },
    getUserDataSuccess: (state, { payload }) => {
      state.userListLoading = false

      state.usersList = payload?.payload?.data
      state.paginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getUserDataFailure: (state, { payload }) => {
      state.userListLoading = false
    },

    //slot type
    setSlotType: (state, { payload }) => {
      state.slotType = payload
      localStorage.setItem('slotType', JSON.stringify(payload))
    },
    getSlotType: (state, { payload }) => {
      let slotType = localStorage.getItem('slotType')
      state.slotType = JSON.parse(slotType)
    },

    //appointment status
    setAppointmentStatus: (state, { payload }) => {
      state.appointmentStatus = payload
      localStorage.setItem('appointmentStatus', JSON.stringify(payload))
    },
    getAppointmentStatus: (state, { payload }) => {
      let appointmentStatus = localStorage.getItem('appointmentStatus')
      state.appointmentStatus = JSON.parse(appointmentStatus)
    },

    //hospital
    getHospitalData: (state, { payload }) => {
      state.hospitalListLoading = true
    },
    getHospitalDataSuccess: (state, { payload }) => {
      state.hospitalListLoading = false
      state.hospitalList = payload?.payload?.data
      state.hospitalPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getHospitalDataFailure: (state, { payload }) => {
      state.hospitalListLoading = false
    },

    //doctor
    getDoctorData: (state, { payload }) => {
      state.doctorListLoading = true
    },
    getDoctorDataSuccess: (state, { payload }) => {
      state.doctorListLoading = false

      state.doctorList = payload?.payload?.data
      state.doctorPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getDoctorDataFailure: (state, { payload }) => {
      state.doctorListLoading = false
    },

    //city
    getCityData: (state, { payload }) => {
      state.errorMsg = ''
      state.cityLoading = true
    },
    getCityDataSuccess: (state, { payload: { payload } }) => {
      state.cityLoading = false
      state.cityList = payload?.data
      state.cityPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getCityDataFailed: (state, { payload }) => {
      state.cityLoading = false
    },

    // add City
    addCityData: (state, { payload }) => {
      state.cityLoading = true
      state.updateCityList = false
    },
    addCityApiSuccess: (state, { payload }) => {
      state.updateCityList = true
      state.cityLoading = false
      state.addCityApiSuccess = true
      state.cityApiError = payload?.payload
    },
    addCityApiFailed: (state, { payload }) => {
      state.cityLoading = false
      alert(payload)
    },

    // update city
    updateCityData: (state, { payload }) => {
      state.cityLoading = true
      state.updateCityList = false
      state.cityList = state.cityList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateCityApiSuccess: (state, { payload }) => {
      state.updateCityList = true
      state.cityLoading = false
      state.editCityApiSuccess = true
      state.cityApiError = payload?.payload
    },
    updateCityApiFailed: (state, { payload }) => {
      state.cityLoading = false
      alert(payload)
    },
    // delete City
    deleteCityData: (state, { payload }) => {
      state.cityLoading = true
      state.updateCityList = false
      let updatedCityList = state.cityList?.filter((item) => item.id !== payload?.id)
      state.cityList = updatedCityList
    },
    deleteCityApiSuccess: (state, { payload }) => {
      state.updateCityList = true
      state.cityLoading = false
      state.deleteCityApiSuccess = true
      state.cityApiError = payload?.payload
    },
    deleteCityApiFailed: (state, { payload }) => {
      state.cityLoading = false
      alert(payload)
    },

    //scanCategory
    getScanCategoryData: (state) => {
      state.errorMsg = ''
    },
    getScanCategoryDataSuccess: (state, { payload: { payload } }) => {
      state.scanCategoryList = payload.data
    },
    getScanCategoryDataFailed: () => {},

    //editUser
    editUserData: (state) => {
      state.errorMsg = ''
    },
    editUserDataSuccess: (state, { payload: { payload } }) => {
      state.cityLoading = false
      state.cityList = payload.data
    },
    editUserDataFailed: (state, { payload }) => {
      state.cityLoading = false
    },

    //deleteUser
    deleteUserData: (state, { payload }) => {
      let updatedUserList = state.usersList?.filter((item) => item.id !== payload?.id)
      state.usersList = updatedUserList
    },
    deleteUserDataSuccess: (state) => {},
    deleteUserDataFailed: (state) => {},

    //addVisitType
    addUserData: (state, { payload }) => {
      const last = state.usersList[state.usersList.length - 1]?.id || 0
      state.usersList = [
        ...state.usersList,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
      state.updateUser = false
    },
    addUserDataSuccess: (state) => {
      state.updateUser = true
    },
    addUserDataFailed: (state) => {
      state.updateUser = false
    },

    //updateDoctor
    updateDoctorData: (state, { payload }) => {
      state.doctorList = state.doctorList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
      state.updateDoctor = false
    },
    updateDoctorDataSuccess: (state, { payload }) => {
      //state.updateDoctor = true
    },
    updateDoctorDataFailed: (state) => {
      state.updateDoctor = false
    },

    //addVisitType
    addDoctorData: (state, { payload }) => {
      const last = state.doctorList[state.doctorList.length - 1]?.id || 0
      state.doctorList = [
        ...state.doctorList,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
      state.updateDoctor = false
    },
    addDoctorDataSuccess: (state) => {
      state.updateDoctor = true
    },
    addDoctorDataFailed: (state) => {
      state.updateDoctor = false
    },

    //getImaBranchData
    getImaBranchData: (state) => {},
    getImaBranchDataSuccess: (state, { payload: { payload } }) => {
      state.imaBranch = payload.data
    },
    getImaBranchDataFailed: (state) => {},

    //deleteDoctor
    deleteDoctorData: (state, { payload }) => {
      let updatedDoctorList = state.doctorList?.filter((item) => item.id !== payload?.id)
      state.doctorList = updatedDoctorList
    },
    deleteDoctorDataSuccess: (state) => {},
    deleteDoctorDataFailed: (state) => {},

    //deleteHospital
    deleteHospitalData: (state, { payload }) => {
      let updatedHospitalList = state.hospitalList?.filter((item) => item.id !== payload?.id)
      state.hospitalList = updatedHospitalList
    },
    deleteHospitalDataSuccess: (state) => {},
    deleteHospitalDataFailed: (state) => {},

    //updateHospital
    updateHospitalData: (state, { payload }) => {
      state.hospitalList = state.hospitalList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateHospitalDataSuccess: (state, { payload }) => {},
    updateHospitalDataFailed: (state) => {},

    //addHospital
    addHospitalData: (state, { payload }) => {
      state.updateHospital = false
    },
    addHospitalDataSuccess: (state, { payload }) => {
      state.updateHospital = true
    },

    addHospitalDataFailed: (state) => {
      state.updateHospital = false
    },

    //Pharmacy
    //getPharmacy
    getPharmacyData: (state, { payload }) => {
      state.pharmacyListLoading = true
    },
    getPharmacyDataSuccess: (state, { payload }) => {
      state.pharmacyListLoading = false
      state.pharmacyList = payload?.payload?.data
      state.pharmacyPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getPharmacyDataFailed: (state, { payload }) => {
      state.pharmacyListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    //updatePharmacy
    updatePharmacyData: (state, { payload }) => {
      state.addPharmacyApiSuccess = true
      state.pharmacyList = state.pharmacyList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updatePharmacyDataSuccess: (state, { payload }) => {
      state.addPharmacyApiSuccess = true
      state.addPharmacyApiError = payload?.payload
    },
    updatePharmacyDataFailed: (state, { payload }) => {
      alert(JSON.stringify(payload, null, 2))
    },

    //deletePharmacy
    deletePharmacyData: (state, { payload }) => {
      let updatedPharmacyList = state.pharmacyList?.filter((item) => item.id !== payload?.id)
      state.pharmacyList = updatedPharmacyList
    },
    deletePharmacyDataSuccess: () => {},
    deletePharmacyDataFailed: () => {},
    //addPharmacy
    addPharmacyData: (state) => {
      state.updatePharmacyList = false
      state.pharmacyListLoading = true
      state.addPharmacyApiSuccess = false
    },
    addPharmacyDataSuccess: (state, { payload }) => {
      state.updatePharmacyList = true
      state.pharmacyListLoading = false
      state.addPharmacyApiSuccess = true
      state.addPharmacyApiError = payload?.payload
    },
    resetPharmacyError: (state) => {
      //state.addSubCategoryError = '' // or [] to reset the errors
      state.addPharmacyApiSuccess = false
      if (state.approvedSuccess) {
        state.approvedSuccess = false
      }
    },
    addPharmacyDataFailed: (state, { payload }) => {
      state.updatePharmacyList = false

      alert(JSON.stringify(payload, null, 2))
    },

    //ScanCenter
    //getScanCenter
    getScanCenterData: (state) => {
      state.scanCenterListLoading = true
    },
    getScanCenterDataSuccess: (state, { payload }) => {
      state.scanCenterListLoading = false
      state.scanCenterList = payload?.payload?.data
      state.scanCenterPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getScanCenterDataFailure: (state) => {
      state.scanCenterListLoading = false
    },
    //updateScanCenter
    updateScanCenterData: (state, { payload }) => {
      state.scanCenterList = state.scanCenterList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateScanCenterDataSuccess: () => {},
    updateScanCenterDataFailed: () => {},
    //deleteScanCenter
    deleteScanCenterData: (state, { payload }) => {
      let updatedScanCenterList = state.scanCenterList?.filter((item) => item.id !== payload?.id)
      state.scanCenterList = updatedScanCenterList
    },
    deleteScanCenterDataSuccess: () => {},
    deleteScanCenterDataFailed: () => {},
    //addScanCenter
    addScanCenterData: (state) => {
      state.updateScanCenter = false
    },
    addScanCenterDataSuccess: (state) => {
      state.updateScanCenter = true
    },
    addScanCenterDataFailed: (state) => {
      state.updateScanCenter = false
    },

    //Laboratory
    //getLaboratory
    getLaboratoryData: (state) => {
      state.laboratoryListLoading = true
    },
    getLaboratoryDataSuccess: (state, { payload }) => {
      state.laboratoryListLoading = false
      state.laboratoryList = payload?.payload?.data
      state.laboratoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getLaboratoryDataFailure: (state) => {
      state.laboratoryListLoading = false
    },
    //updateLaboratory
    updateLaboratoryData: (state, { payload }) => {
      state.laboratoryList = state.laboratoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateLaboratoryDataSuccess: () => {},
    updateLaboratoryDataFailed: () => {},
    //deleteLaboratory
    deleteLaboratoryData: (state, { payload }) => {
      let updatedLaboratoryList = state.laboratoryList?.filter((item) => item.id !== payload?.id)
      state.laboratoryList = updatedLaboratoryList
    },
    deleteLaboratoryDataSuccess: () => {},
    deleteLaboratoryDataFailed: () => {},
    //addLaboratory
    addLaboratoryData: (state) => {
      state.updateLaboratory = false
    },
    addLaboratoryDataSuccess: (state) => {
      state.updateLaboratory = true
    },
    addLaboratoryDataFailed: (state) => {
      state.updateLaboratory = false
    },

    //Ambulance
    //getAmbulance
    getAmbulanceData: (state) => {
      state.ambulanceListLoading = true
    },
    getAmbulanceDataSuccess: (state, { payload }) => {
      state.ambulanceListLoading = false
      state.ambulanceList = payload?.payload?.data
      state.laboratoryPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getAmbulanceDataFailed: (state) => {
      state.ambulanceListLoading = false
    },
    //updateAmbulance
    updateAmbulanceData: (state, { payload }) => {
      state.updateAmbulance = false
      state.ambulanceList = state.ambulanceList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateAmbulanceDataSuccess: (state, { payload }) => {
      state.updateAmbulance = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    updateAmbulanceDataFailed: (state, { payload }) => {
      state.updateAmbulance = false
      alert(JSON.stringify(payload, null, 2))
    },
    //deleteAmbulance
    deleteAmbulanceData: (state, { payload }) => {
      state.updateAmbulance = false
      let updatedAmbulanceList = state.ambulanceList?.filter((item) => item.id !== payload?.id)
      state.ambulanceList = updatedAmbulanceList
    },
    deleteAmbulanceDataSuccess: (state, { payload }) => {
      state.updateAmbulance = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    deleteAmbulanceDataFailed: (state, { payload }) => {
      state.updateAmbulance = false
      alert(JSON.stringify(payload, null, 2))
    },
    //addAmbulance
    addAmbulanceData: (state, { payload }) => {
      state.ambulanceListLoading = true
      state.updateAmbulance = false
      state.modalOpen = false
      state.ApiError = ''
    },
    addAmbulanceDataSuccess: (state, { payload }) => {
      state.ambulanceListLoading = false
      state.updateAmbulance = true
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    addAmbulanceDataFailed: (state, { payload }) => {
      state.ambulanceListLoading = false
      state.updateAmbulance = false
      alert(JSON.stringify(payload, null, 2))
    },

    //Booking
    //getBookingList
    getBookingList: (state) => {
      state.bookingListLoading = true
    },
    getBookingListSuccess: (state, { payload }) => {
      state.bookingListLoading = false
      state.bookingList = payload?.payload?.data
    },
    getBookingListFailure: (state) => {
      state.bookingListLoading = false
    },
    //updateBookingList
    updateBookingList: (state, { payload }) => {
      state.bookingList = state.bookingList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateBookingListSuccess: () => {},
    updateBookingListFailed: () => {},
    //deleteBookingList
    deleteBookingList: (state, { payload }) => {
      let updateBookingList = state.bookingList?.filter((item) => item.id !== payload?.id)
      state.bookingList = updateBookingList
    },
    deleteBookingListSuccess: () => {},
    deleteBookingListFailed: () => {},
    //addBookingList
    addBookingList: (state) => {
      state.updateBooking = false
    },
    addBookingListSuccess: (state) => {
      state.updateBooking = true
    },
    addBookingListFailed: (state) => {
      state.updateBooking = false
    },
    //getBookingDetails
    getBookingDetailsData: (state) => {
      state.detailBookingLoading = true
    },
    getBookingDetailsDataSuccess: (state, { payload }) => {
      state.detailBookingLoading = false
      state.detailBookingData = payload?.payload?.data
    },
    getBookingDetailsDataFailed: (state) => {
      state.detailBookingLoading = false
    },

    //ambulanceType
    getAmbulanceTypeListData: () => {},
    getAmbulanceTypeListDataSuccess: (state, { payload: { payload } }) => {
      state.ambulanceType = payload.data
    },
    getAmbulanceTypeListDataFailed: () => {},

    //ambulanceFacility
    getAmbulanceFacilitiesListData: () => {},
    getAmbulanceFacilitiesListDataSuccess: (state, { payload: { payload } }) => {
      state.ambulanceFacilities = payload.data
    },
    getAmbulanceFacilitiesListDataFailed: () => {},

    //appointmentDuration
    getAppointmentDurationListData: () => {},
    getAppointmentDurationListDataSuccess: (state, { payload: { payload } }) => {
      state.appointmentDuration = payload.data
    },
    getAppointmentDurationListDataFailed: () => {},

    //Appointment Status
    getAppointmentStatusList: () => {},
    getAppointmentStatusListSuccess: (state, { payload: { payload } }) => {
      state.appointmentStatus = payload.data
    },
    getAppointmentStatusListFailed: () => {},

    //Doctor Slot
    getDoctorSlotList: () => {},
    getDoctorSlotListSuccess: (state, { payload: { payload } }) => {
      state.doctorSlotList = payload.data
    },
    getDoctorSlotListFailed: () => {},

    // Approved Pharmacy
    approvedPharmacyDataApiCall: (state, { payload: { payload } }) => {
      state.approvedSuccess = false
    },
    approvedPharmacyDataSuccess: (state, { payload }) => {
      state.approvedSuccess = true
      state.addPharmacyApiError = payload?.payload
    },
    approvedPharmacyDataFailed: (state, { payload: { payload } }) => {
      state.approvedSuccess = false
    },
    resetProviderManagementError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },

    resetCityError: (state) => {
      state.addCityApiSuccess = false
      state.deleteCityApiSuccess = false
      state.editCityApiSuccess = false
      state.cityApiError = null
      state.updateCityList = false
    },
  },
})

export const {
  getUserData,
  getUserDataSuccess,
  getUserDataFailure,

  setSlotType,
  getSlotType,

  setAppointmentStatus,
  getAppointmentStatus,

  getDoctorData,
  getDoctorDataSuccess,
  getDoctorDataFailure,

  getCityData,
  getCityDataSuccess,
  getCityDataFailed,

  //scanCenter
  getScanCategoryData,
  getScanCategoryDataSuccess,
  getScanCategoryDataFailed,

  getHospitalData,
  getHospitalDataSuccess,
  getHospitalDataFailure,

  editUserData,
  editUserDataSuccess,
  editUserDataFailed,

  //updateUser
  deleteUserData,
  deleteUserDataSuccess,
  deleteUserDataFailed,

  //addUser
  addUserData,
  addUserDataSuccess,
  addUserDataFailed,

  //updateDoctor
  updateDoctorData,
  updateDoctorDataSuccess,
  updateDoctorDataFailed,

  //addDoctor
  addDoctorData,
  addDoctorDataSuccess,
  addDoctorDataFailed,

  //getImaBranchData
  getImaBranchData,
  getImaBranchDataSuccess,
  getImaBranchDataFailed,

  // deleteDoctor
  deleteDoctorDataSuccess,
  deleteDoctorDataFailed,
  deleteDoctorData,

  // deleteHospital
  deleteHospitalDataSuccess,
  deleteHospitalDataFailed,
  deleteHospitalData,

  //updateHospital
  updateHospitalData,
  updateHospitalDataSuccess,
  updateHospitalDataFailed,

  //addHospital
  addHospitalData,
  addHospitalDataSuccess,
  addHospitalDataFailed,

  //pharmacy
  //getPharmacy
  getPharmacyData,
  getPharmacyDataSuccess,
  getPharmacyDataFailed,

  //updatePharmacy
  updatePharmacyData,
  updatePharmacyDataSuccess,
  updatePharmacyDataFailed,

  //addPharmacy
  addPharmacyData,
  addPharmacyDataSuccess,
  addPharmacyDataFailed,

  //deletePharmacy
  deletePharmacyData,
  deletePharmacyDataSuccess,
  deletePharmacyDataFailed,

  //scan-center
  //getScanCenter
  getScanCenterData,
  getScanCenterDataSuccess,
  getScanCenterDataFailed,

  //updateScanCenter
  updateScanCenterData,
  updateScanCenterDataSuccess,
  updateScanCenterDataFailed,

  //addScanCenter
  addScanCenterData,
  addScanCenterDataSuccess,
  addScanCenterDataFailed,

  //deleteScanCenter
  deleteScanCenterData,
  deleteScanCenterDataSuccess,
  deleteScanCenterDataFailed,

  //laboratory
  //getLaboratory
  getLaboratoryData,
  getLaboratoryDataSuccess,
  getLaboratoryDataFailed,

  //updateLaboratory
  updateLaboratoryData,
  updateLaboratoryDataSuccess,
  updateLaboratoryDataFailed,

  //addLaboratory
  addLaboratoryData,
  addLaboratoryDataSuccess,
  addLaboratoryDataFailed,

  //deleteLaboratory
  deleteLaboratoryData,
  deleteLaboratoryDataSuccess,
  deleteLaboratoryDataFailed,

  //ambulance
  //getAmbulance
  getAmbulanceData,
  getAmbulanceDataSuccess,
  getAmbulanceDataFailed,

  //updateAmbulance
  updateAmbulanceData,
  updateAmbulanceDataSuccess,
  updateAmbulanceDataFailed,

  //addAmbulance
  addAmbulanceData,
  addAmbulanceDataSuccess,
  addAmbulanceDataFailed,

  //deleteAmbulance
  deleteAmbulanceData,
  deleteAmbulanceDataSuccess,
  deleteAmbulanceDataFailed,

  //Ambulance Type
  getAmbulanceTypeListData,
  getAmbulanceTypeListDataSuccess,
  getAmbulanceTypeListDataFailed,

  //Ambulance facilities
  getAmbulanceFacilitiesListData,
  getAmbulanceFacilitiesListDataSuccess,
  getAmbulanceFacilitiesListDataFailed,

  //Appointment Duration
  getAppointmentDurationListData,
  getAppointmentDurationListDataSuccess,
  getAppointmentDurationListDataFailed,

  //Appointment Status
  getAppointmentStatusList,
  getAppointmentStatusListSuccess,
  getAppointmentStatusListFailed,

  //Doctor Slot
  getDoctorSlotListSuccess,
  getDoctorSlotListFailed,
  getDoctorSlotList,

  //Booking
  //Get Booking
  getBookingList,
  getBookingListSuccess,
  getBookingListFailed,

  //Update Booking
  updateBookingList,
  updateBookingListSuccess,
  updateBookingListFailed,

  //Add Booking
  addBookingList,
  addBookingListSuccess,
  addBookingListFailed,

  //Delete Booking
  deleteBookingList,
  deleteBookingListSuccess,
  deleteBookingListFailed,

  //Booking Details
  getBookingDetailsData,
  getBookingDetailsDataSuccess,
  getBookingDetailsDataFailed,
  // reset Pharmacy Error
  resetPharmacyError,

  // Approved Pharmacy
  approvedPharmacyDataApiCall,
  approvedPharmacyDataSuccess,
  approvedPharmacyDataFailed,

  // add City
  addCityData,
  addCityApiSuccess,
  addCityApiFailed,

  // update city
  updateCityData,
  updateCityApiSuccess,
  updateCityApiFailed,
  // delete City
  deleteCityData,
  deleteCityApiSuccess,
  deleteCityApiFailed,
  // reset error
  resetCityError,
  resetProviderManagementError,
} = slice.actions

export default slice.reducer
